import offlineStore from './offlineStoreApi';
import firebaseApp from './firebaseClient';

const db = firebaseApp.db;
const userCollection = db.collection('users');
let userDoc;

export default {
  init(store) {
    offlineStore.getReturningUserFlag().then((returningUser) => {
      store.dispatch('newUserVisit', !returningUser);
    });

    firebaseApp.firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        store.dispatch('getUser', user);
        offlineStore.setReturningUserFlag();
      } else {
        this.signInAnonymously();

        // store.commit('RECEIVE_USER', { user: {} });
        // offlineStore.setLastActivity({
        //   recentPresentations: []
        // });
      }
    });

    if (firebaseApp.firebase.auth().isSignInWithEmailLink(window.location.href)) {
      const params = new URLSearchParams(window.location.search);
      const platform = params.get('p');
      if (platform === 'desktop') {
        window.location.href = `at-and://sign-in-user?l=${window.location.search}`;
        return;
      }

      let email = window.localStorage.getItem('emailForSignIn');
      if (!email) {
        email = window.prompt('Please provide your email for confirmation');
      }

      this.signInWithLink(store, email, window.location.href, params);
    }
  },

  signInWithLink(store, email, link, params) {
    firebaseApp.firebase.auth().signInWithEmailLink(email, link)
      .then((result) => {
        window.localStorage.removeItem('emailForSignIn');
        const prevUserId = params.get('r');
        const presentationId = params.get('n');

        if (!result.user.displayName) {
          const displayName = window.prompt('Please provide your name');
          store.dispatch('updateUserProfileData', {
            firebaseUser: result.user,
            displayName
          });
        }

        if (prevUserId !== null) {
          this.switchUser(prevUserId, result.user.uid, store)
            .then(() => {
              if (presentationId !== null) {
                store.dispatch('viewPresentationAfterSignIn', presentationId);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }

        store.dispatch('userLoggedIn');

        console.log('Signed in', result.user.uid);
      })
      .catch((error) => {
        console.log(error, error.code);
      });
  },

  switchUser(prevUserId, currentUserId, store) {
    const currentUserAttendedDoc = userCollection.doc(currentUserId).collection('attended');
    const prevUserAttendedDoc = userCollection.doc(prevUserId).collection('attended');

    return new Promise((resolve, reject) => {
      currentUserAttendedDoc.get().then((currentAttendedCollectionSnapshot) => {
        prevUserAttendedDoc.get().then((prevAttendedCollectionSnapshot) => {
          this.mergeAttended(
            currentAttendedCollectionSnapshot,
            prevAttendedCollectionSnapshot,
            store
          );

          userCollection.doc(prevUserId).delete().then(() => {
            console.log('Previous user successfully deleted');
            resolve();
          }).catch((error) => {
            console.error('Error removing document: ', error);
            reject('Error removing document: ', error);
          });
        });
      });
    });
  },

  mergeAttended(currentAttendedCollectionSnapshot, prevAttendedCollectionSnapshot, store) {
    const mergedAttended = {};
    const currentAttendedPresentationIds = [];
    const attendedCollection = [];

    currentAttendedCollectionSnapshot.forEach((attended) => {
      const attendData = attended.data();
      mergedAttended[attended.id] = attendData;
      currentAttendedPresentationIds.push(attendData.presentationId);
    });

    prevAttendedCollectionSnapshot.forEach((attended) => {
      const attendData = attended.data();
      if (currentAttendedPresentationIds.indexOf(attendData.presentationId) === -1) {
        mergedAttended[attended.id] = attendData;
      }

      attended.ref.delete().then(() => {
        console.log('Document successfully deleted!');
      }).catch((error) => {
        console.error('Error removing document: ', error);
      });
    });

    Object.entries(mergedAttended).forEach(([attendedId, attended]) => {
      userDoc.collection('attended').doc(attendedId).set(attended);
      attendedCollection.push(Object.assign(
        { attendedId },
        attended
      ));
    });

    store.dispatch('fetchRecentAttendedPresentations', attendedCollection);
  },

  fetchUser(firebaseUser, cb) {
    userDoc = userCollection.doc(firebaseUser.uid);

    userDoc.set({
      signedIn: firebaseUser.metadata.lastSignInTime,
      userId: firebaseUser.uid
    }, { merge: true }).then(() => {
      userDoc.get().then((doc) => {
        if (doc.exists) {
          const userData = doc.data();
          userData.userId = firebaseUser.uid;

          cb(userData);
        } else {
          cb({});
          console.log('No such user');
        }
      }).catch((error) => {
        console.log('Error getting user:', error);
      });
    }).catch((error) => {
      console.error('Error writing user: ', error);
    });
  },

  fetchAttendedPresentations() {
    return userDoc.collection('attended').orderBy('attendingDate', 'desc').get();
  },

  updateUserProfile(firebaseUser, displayName, photoURL) {
    return firebaseUser.updateProfile({
      displayName,
      photoURL
    });
  },

  addAttendance(attendedData) {
    return userDoc.collection('attended').doc(attendedData.presentationId).set(attendedData, { merge: true });
  },

  updateAttendance(attendedId) {
    return userDoc.collection('attended').doc(attendedId).update({
      attendingDate: firebaseApp.firebase.firestore.Timestamp.now()
    });
  },

  updateFavoriteSlide(attended) {
    return userDoc.collection('attended').doc(attended.attendedId).update({
      favorites: attended.favorites
    });
  },

  updateUser(updatedProperties) {
    return userDoc.update(updatedProperties);
  },

  signInAnonymously() {
    firebaseApp.firebase.auth().signInAnonymously().catch((error) => {
      console.log(`${error.code}:${error.message}`);
    });
  },

  signOut() {
    return firebaseApp.firebase.auth().signOut();
  }
};



// WEBPACK FOOTER //
// ./src/api/userApi.js